<div class="rounded-2xl border-2 border-neutral-50 bg-neutral-50 p-4">
  @if (changedFields().length === 0) {
    <div class="text-sm text-neutral-400">Немає змін для відображення</div>
  } @else {
    <div class="flex gap-4">
      <!-- 1) Left ID column -->
      <h2 class="flex w-10 shrink-0 items-center text-neutral-400">
        {{ prescriptionChange().id }}
      </h2>

      <!-- Middle content -->
      <div class="flex grow flex-col">
        @for (fieldChange of changedFields(); track fieldChange.fieldName) {
          <div class="flex items-center gap-2 border-b border-neutral-100 last:border-0">
            <!-- 2) Label -->
            <p class="w-32 shrink-0 text-xs font-medium text-neutral-600">
              {{ fieldChange.label }}
            </p>

            <!-- 3) Old value -->
            <p class="bg-red-100 text-red-800 flex flex-1 justify-end rounded px-2 py-1 text-sm">
              @switch (fieldChange.fieldName) {
                @case ("guaranteeStatus") {
                  <shared-status
                    [statusValue]="fieldChange.oldValue"
                    [statusMessage]="'statuses.guarantationStatuses.' + fieldChange.oldValue | translate"
                  ></shared-status>
                }
                @default {
                  {{ fieldChange.oldValue }}
                }
              }
            </p>

            <!-- 4) Arrow -->
            <p class="flex w-6 shrink-0 justify-center text-neutral-400">→</p>

            <!-- 5) New value -->
            <p class="bg-green-100 text-green-800 flex-1 rounded px-2 py-1 text-sm">
              @switch (fieldChange.fieldName) {
                @case ("guaranteeStatus") {
                  <shared-status
                    [statusValue]="fieldChange.newValue"
                    [statusMessage]="'statuses.guarantationStatuses.' + fieldChange.newValue | translate"
                  ></shared-status>
                }
                @default {
                  {{ fieldChange.newValue }}
                }
              }
            </p>
          </div>
        }
      </div>
    </div>
  }
</div>
